/*
 * Product Thumbnail Slider Interaction
 */

custom.pdpThumbnails = (function () {
  const scrollContainer = $(
    '.product-detail__thumbnails .js-pdp-sticky.vertical-scroll',
  );
  const upButton = $('.product-detail__thumbnails .scroll-prev');
  const downButton = $('.product-detail__thumbnails .scroll-next');

  const THUMBNAIL_VISIBILITY_THRESHOLD = 50;
  let thumbnailHeight = 0;
  let currentIndex = 0;
  let thumbnails = [];

  function getThumbnails() {
    if (!scrollContainer.length) return;

    // Get all thumbnails and store them
    thumbnails = scrollContainer.find('.js-product-scroll').toArray();

    // Grab the height of the first thumbnail
    const firstThumbnail = $(thumbnails[0]);
    if (firstThumbnail.length) {
      thumbnailHeight = firstThumbnail.outerHeight(true);
    }
  }

  function handleClick() {
    if (!scrollContainer.length || !upButton.length || !downButton.length) {
      return;
    }

    const scrollTop = scrollContainer.scrollTop();
    const scrollHeight = scrollContainer[0].scrollHeight;
    const clientHeight = scrollContainer.height();

    // Hide the buttons if there are less than 9 items
    upButton.toggleClass(
      'scroll-hidden',
      scrollHeight - clientHeight < THUMBNAIL_VISIBILITY_THRESHOLD,
    );
    downButton.toggleClass(
      'scroll-hidden',
      scrollHeight - clientHeight < THUMBNAIL_VISIBILITY_THRESHOLD,
    );

    // Disable prev button if at the top
    upButton.toggleClass('scroll-disabled', scrollTop <= 0);
    upButton.attr('aria-disabled', scrollTop <= 0);

    // Disable next button if at the bottom
    const isAtBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    downButton.toggleClass('scroll-disabled', isAtBottom);
    downButton.attr('aria-disabled', isAtBottom);

    // Update current index based on scroll position
    currentIndex = Math.round(scrollTop / thumbnailHeight);
  }

  function animateScroll(direction) {
    if (!scrollContainer.length) return;

    let targetIndex;

    // Scroll up or down by one thumbnail
    if (direction === 'next') {
      targetIndex = Math.min(currentIndex + 1, thumbnails.length - 1);
    } else {
      targetIndex = Math.max(currentIndex - 1, 0);
    }

    scrollContainer.animate(
      { scrollTop: targetIndex * thumbnailHeight },
      {
        duration: 300,
        complete: function () {
          currentIndex = targetIndex;
          handleClick();
        },
      },
    );
  }

  function init() {
    if (!scrollContainer.length) return;

    getThumbnails();
    upButton.on('click', () => animateScroll('prev'));
    downButton.on('click', () => animateScroll('next'));
    //scrollContainer.on('scroll', handleClick);
    $(window).on('resize', handleClick);
    handleClick();
  }

  return {
    init: init,
  };
})();

custom.pdpThumbnails.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-thumbnails.js